import {
  RecentDocumentClient,
  RecentDocumentReq,
  TreeNodeDTO,
} from 'business/models/Models';
import ModelFactory from 'business/models/ModelFactory';
import BaseService from './BaseService';

export default class RecentDocumentService extends BaseService {
  async saveDocumentToRecents(treeNodeId: number) {
    const _recentDocumentClient: RecentDocumentClient =
      ModelFactory(RecentDocumentClient);
    const requestData: RecentDocumentReq = new RecentDocumentReq();
    requestData.documentId = treeNodeId;
    await _recentDocumentClient.saveRecentDocument(requestData);
  }
  async getUserRecentDocuments(): Promise<TreeNodeDTO[]> {
    const _recentDocumentClient: RecentDocumentClient = ModelFactory(
      RecentDocumentClient,
      false,
      true,
    );
    const recentDocs: TreeNodeDTO[] =
      await _recentDocumentClient.getUserRecentDocuments();

    return await recentDocs;
  }
  async getHitImageExperiments(): Promise<TreeNodeDTO[]> {
    const _recentDocumentClient: RecentDocumentClient = ModelFactory(
      RecentDocumentClient,
      false,
      true,
    );
    const recentImagingExperiments: TreeNodeDTO[] =
      await _recentDocumentClient.getHitImagesExperiments();

    return await recentImagingExperiments;
  }
}
